<template>
  <div v-bind:style='{left:obj.view.left + "px", top:obj.view.top + "px", width:obj.view.w + "px", height:obj.view.h + "px"}' class='flowchart-object jsplumb-draggable jsplumb-droppable' :id="obj.view.id">
    <div class="sms_shell">
      <div class="title control">
        <div class="smsTitle">{{$t('scenarios.konstruktor.canvas.add.sendSMS')}}</div>
        <button class="delete" aria-label="delete" v-on:click="deleteNode()"></button>
      </div>

      <div style="margin-top: 6px">
        <div class="is-overlay overlay-for-not-admin"/>
        <div class="field is-horizontal">
          <div class="field-label is-normal is-inline-block">
            <label class="label">{{$t('scenarios.konstruktor.canvas.answer.sms.gateway')}}</label>
          </div>
          <div class="field-body is-inline-block">
            <div class="field is-narrow">
              <div class="control">
                <div class="select is-fullwidth">
                  <select name="smsGateway" class="smsGateway" v-model="obj.data.gateway">
                    <option v-for="gateway in obj.availableSmsGateways" v-bind:value="gateway" >
                      {{gateways[gateway]}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="field-body is-inline-block sender-field">
            <div class="field-label is-normal is-inline-block">
              <label class="label">{{$t('scenarios.konstruktor.canvas.answer.sms.sender')}}</label>
            </div>
            <div class="field-body is-inline-block">
              <div class="field is-narrow">
                <div class="control">
                  <input class="input sender" v-model="obj.data.sender" />
                </div>
              </div>
            </div>

          </div>
        </div>
        <textarea v-model="obj.data.text" :placeholder="$t('scenarios.konstruktor.canvas.answer.sms.messageText')" :title="$t('scenarios.konstruktor.canvas.answer.sms.messageText')" class="textarea smsText"/>
      </div>

    </div>
  </div>
</template>

<script>
  import { BaseNodeComponent } from './jsplumb-extends/jsplumb-vue'

  export default {
    name: 'Sms',
    mixins:[ BaseNodeComponent ],
    props: [],
    data() {
      return {
        gateways : {
          smsc: 'Smsc Default',
          smscFit19: 'Smsc Fit19',
          fitservicesms: 'Fit Service',
          semySms: 'Semy Sms',
          acemaoutMedia: 'Acemout Media',
          smsClub: 'Sms club'
        }
      }
    },
    created() {
      if (this.obj.availableSmsGateways && this.obj.availableSmsGateways.length >= 1 && !this.obj.data.gateway) {
        this.obj.data.gateway = this.obj.availableSmsGateways[0]
      }
    }
  }
</script>

<style scoped>
  .sms_shell {
    border-radius: 10px;
    vertical-align: top;
    background-color: ghostwhite;
    padding: 10px;
    /*height: 100%;*/
    /*width: 512px;*/
  }
  .title .delete {
    float: right;
    background-color: indianred;
    cursor: pointer;
  }
  .title {
    font-size: 16px;
    white-space: nowrap;
    text-align: left;
    height: 32px;
    margin-bottom: 0;
    display: inline;
  }

  .sms_shell .title .smsTitle {
    padding-right: 16px;
    font-size: 16px;
  }

  .sms_shell .title div {
    display: inline;
  }

  .smsText {
    height: 80px;
    min-height: 80px;
    min-max: 80px;
    resize: none;
  }

  .field {
    float:left;
    vertical-align: middle;
    margin-bottom: -10px;
  }
  .field-label {
    height: 40px;
  }

  .is-overlay {
    /*height: 155px;*/
    z-index: 100;
  }

  .sender-field {
    margin-left:16px;
  }
  input.sender {
    max-width: 128px;
  }
</style>




// WEBPACK FOOTER //
// Sms.vue?063f6d47